import { z } from 'zod';

export const contactMethodSchema = z.enum(['telegram', 'whatsapp']);
export type ContactMethod = z.infer<typeof contactMethodSchema>;

export const orderStatusSchema = z.enum([
  'pending_telegram',
  'pending_confirmation',
  'confirmed',
  'cancelled',
]);
export type OrderStatus = z.infer<typeof orderStatusSchema>;

export const checkoutFormSchema = z.object({
  customerName: z.string().min(2, 'يرجى إدخال اسمك الكامل'),
  phone: z.string().min(9, 'يرجى إدخال رقم هاتف صحيح'),
  wilaya: z.string().min(2, 'يرجى اختيار الولاية'),
  commune: z.string().optional().default(''),
  address: z.string().min(3, 'يرجى كتابة العنوان بالتفصيل'),
  notes: z.string().optional().default(''),
});
export type CheckoutFormValues = z.infer<typeof checkoutFormSchema>;

export const orderItemSchema = z.object({
  productId: z.string(),
  variantId: z.string().optional(),
  productName: z.string(),
  variantName: z.string().optional(),
  price: z.number().nonnegative(),
  quantity: z.number().int().positive(),
});
export type OrderItemInput = z.infer<typeof orderItemSchema>;

export const createOrderSchema = checkoutFormSchema.extend({
  contactMethod: contactMethodSchema.default('telegram'),
  items: z.array(orderItemSchema).min(1, 'سلة الطلبات فارغة'),
});
export type CreateOrderInput = z.infer<typeof createOrderSchema>;

export const orderSchema = z.object({
  id: z.string(),
  orderNumber: z.string(),
  customerName: z.string(),
  phone: z.string(),
  wilaya: z.string(),
  commune: z.string().optional().default(''),
  address: z.string(),
  notes: z.string().optional().default(''),
  contactMethod: contactMethodSchema,
  status: orderStatusSchema,
  items: z.array(orderItemSchema),
  total: z.number().nonnegative(),
  telegramChatId: z.string().nullable().optional(),
  telegramLinkToken: z.string().nullable().optional(),
  telegramLastError: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string().optional(),
});
export type Order = z.infer<typeof orderSchema>;

export type NewOrder = CreateOrderInput & {
  orderNumber: string;
  total: number;
};
